import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

export default function Hero() {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        pt: 8,
        pb: 6,
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <QrCodeScannerIcon sx={{ fontSize: 60, color: 'primary.main' }} />
        </Box>
        <Typography
          component="h1"
          variant="h2"
          align="center"
          color="text.primary"
          gutterBottom
        >
          QR Code Scanner
        </Typography>
        <Typography variant="h5" align="center" color="text.secondary" paragraph>
          Scan QR codes to redeem your NFTs and access exclusive content
        </Typography>
      </Container>
    </Box>
  );
} 